import classnames from "classnames";
import * as PropTypes from "prop-types";
import React from "react";

import { Error } from "../../fields/error";
import { Label } from "../../fields/label";

import styles from "./RadioGroup.module.scss";

const RadioGroup = ({
  className,
  label,
  children,
  id,
  error,
  disabled,
  name,
  onChange,
}) => {
  return (
    <div className={classnames(styles.root, className)}>
      {label && (
        <Label
          className={classnames(styles.label, "mb-2", {
            [styles.disabled]: disabled,
          })}
          htmlFor={id}
        >
          {label}
        </Label>
      )}
      <div className={styles.list}>
        {React.Children.map(children, (child) =>
          React.cloneElement(child, { name, onChange, disabled, error }),
        )}
      </div>
      {error && <Error className="mt-3">{error}</Error>}
    </div>
  );
};

RadioGroup.propTypes = {
  children: PropTypes.node,
  label: PropTypes.node,
  error: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
};

export default RadioGroup;
